export const GET_MESSAGE_HOT = 'GET_MESSAGE_HOT';
export const SET_MESSAGE_HOT = 'SET_MESSAGE_HOT';

export const DELETE_MESSAGE_HOT = 'DELETE_MESSAGE_HOT';
export const UPDATE_MESSAGE_HOT = 'UPDATE_MESSAGE_HOT';

export const GET_MESSAGE_LIST = 'GET_MESSAGE_LIST';
export const SET_MESSAGE_COMMENT_LIST = 'SET_MESSAGE_COMMENT_LIST';
export const SET_MESSAGE_COLLECT_LIST = 'SET_MESSAGE_COLLECT_LIST';

export const RESET_MESSAGE_LIST = 'RESET_MESSAGE_LIST';

export const SET_MESSAGE_COMMENT_LOADING = 'SET_MESSAGE_COMMENT_LOADING';
export const SET_MESSAGE_COLLECT_LOADING = 'SET_MESSAGE_COLLECT_LOADING';

export const UPDATE_MESSAGE_LIST = 'UPDATE_MESSAGE_LIST';
export const SET_MESSAGE_ZAN = 'SET_MESSAGE_ZAN';
